import React from 'react';
import { Icon } from '@blueprintjs/core';
import styled from 'styled-components';
import colors from 'utils/colors';
import {
  NavigationControls,
  NavigationLink,
} from 'components/styled-components';
import Loading from 'components/loading';

const VendorRequestNavigation = props => (
  <NavigationControls>
    {props.currentStep === 2 ? (
      <NavigationLink onClick={() => props.handleGoBack(props.validateForm)}>
        <Icon
          icon="arrow-left"
          color={colors.primary}
          iconSize={16}
          style={{ marginRight: '0.25rem' }}
        />
        <span>SPONSOR & THIRD PARTY INFORMATION</span>
      </NavigationLink>
    ) : (
      <div />
    )}

    <ControlGroup>
      {props.currentStep === 1 ? (
        <Button
          type="button"
          disabled={!props.isValid}
          onClick={e => {
            e.preventDefault();

            props.setTouched({
              sponsor: {
                firstName: true,
                lastName: true,
                email: true,
                department: true,
              },
              departmentsRequesting: true,
              vendorInformation: true,
              productServiceName: true,
              vendorContact: [{
                firstName: true,
                lastName: true,
                email: true,
              }],
            });
            props.validateForm().then(res => {
              if (Object.keys(res).length === 0 && res.constructor === Object) {
                props.nextPage();
              }
            });
          }}
        >
          <span>Continue</span>
        </Button>
      ) : (
        <Button type="submit" disabled={!props.isValid || props.isSubmitting}>
          <span>Submit Assessment</span>
          <span style={{ marginLeft: '1rem' }}>
            {props.isSubmitting && <Loading size={20} />}
          </span>
        </Button>
      )}
    </ControlGroup>
  </NavigationControls>
);

const ControlGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
`;

const Button = styled.button`
  border: none;
  border-radius: 5px;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  background: ${colors.primary};
  cursor: pointer;
  padding: 1rem 3rem;
  display: flex;
  align-items: center;
  margin: 5px 2rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  outline: none;
  position: relative;
  color: #fff;
  box-shadow: 0 6px ${colors.secondary};

  &:after {
    content: '';
    position: absolute;
    z-index: -1;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
  }

  &:hover {
    box-shadow: 0 4px ${colors.secondary};
    top: 2px;
  }

  &:active {
    box-shadow: 0 0 ${colors.secondary};
    top: 6px;
  }

  &:disabled {
    background: ${colors.lightGray};
    box-shadow: 0 6px ${colors.gray};
    cursor: not-allowed;
  }
`;

export default VendorRequestNavigation;
